export default "__VITE_ASSET__ENvS_83O__"